import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import {AuthService} from '../authService/auth.service';
import {Observable} from 'rxjs';
import * as JWT_DECODE from 'jwt-decode';
import {CacheService} from '../cacheService/cache.service';
import {EventsService} from '../eventServices/event.service';
import {DecryptService} from '../decryptService/decrypt.service';
import {environment as ENV} from '../../../environments/environment';
import {BootstrapNotifyService} from '../bootstrap-notify/bootstrap-notify.service';
@Injectable()
export class GuardService  {
  url: string;
  constructor( private router: Router, private eventsService: EventsService,
               private decrypt: DecryptService,
               private bootstrapNotify: BootstrapNotifyService,
               private authService: AuthService, private cache_: CacheService, private cacheService: CacheService) {
  }

  /**
   *
   * @param {ActivatedRouteSnapshot} route
   * @param {RouterStateSnapshot} state
   * @returns {Observable<boolean> | Promise<boolean> | boolean}
   */
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    // this.url = state.url;
    return this.checkLogin();
  }
  /**
   * Check member login
   * @param {string} url
   * @returns {boolean}
   */
  checkLogin(): boolean {
    const token = sessionStorage.getItem(ENV.TOKEN).split(' ')[1];
    if(token){
      return true;
    }
    this.router.navigate([ '/' ]); // then ask user to login
    this.logOut();
    return false;
  }

  /**
   * Log out from system
   */
  logOut() {
    this.cache_.clearStorage();
    this.cache_.clearSession();
  }

}
@Injectable()
export class RoleService  {
  static getAuthUser() {
    return JSON.parse(sessionStorage.getItem(ENV.USERTOKEN));
  }
  static checkRole(roles: Array<string>): boolean {
    if(!roles.length) return false;
    const user = RoleService.getAuthUser();
    const userRole = user.role.toLowerCase();
    if(userRole === 'admin' && roles.includes('admin') && roles[0] === 'admin') {
      return true;
    } else {
      if(userRole === 'user') {
        const userDataRoles = user.roles;
        for(let role of userDataRoles) {
          if(roles.includes(role.name)) {
            return true;
          }
        }
        return false;
      } else {
        return false;
      }
    }
  }
  constructor( ) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    let roles: any = route.data;
    // console.log('ROLE DATA ', roles);
    return RoleService.checkRole(roles.roles);
  }
  }
